/**
 * Vue 3 migration — `COMPONENT_V_MODEL: false` on components that use `modelValue` / `update:modelValue`.
 *
 * Set `compatConfig: { COMPONENT_V_MODEL: false }` on any component that binds v-model with the Vue 3
 * convention (`modelValue` prop + `update:modelValue` emit). See StandardModal as an example.
 *
 * Guidelines:
 * - Use `useVModel` from `@vueuse/core` for v-model value binding in `setup`.
 * - Do not override `eventName` to `'input'` — Vue 3 emits `update:modelValue`, and `useVModel` uses that by default.
 * - Declare `modelValue` in `props` and `'update:modelValue'` in `emits` (or rely on `useVModel` without a custom event name).
 */
const config = {
  MODE: 2,
  COMPILER_NATIVE_TEMPLATE: false,
};

export default config;
